import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { observer } from 'mobx-react-lite';
import Avatar from '@mui/material/Avatar';
// import Avatar from '@mui/joy/Avatar';

import Card from '@mui/joy/Card';
import Chip from '@mui/joy/Chip';

import ListItemDecorator from '@mui/joy/ListItemDecorator';
import ListItemContent from '@mui/joy/ListItemContent';
import Stack from '@mui/joy/Stack';
import Skeleton from '@mui/joy/Skeleton';
import { Identity } from 'stores/identity_store';

import Typography from '@mui/joy/Typography';
import Tooltip from '@mui/joy/Tooltip';

// import useUserIdentity from 'hooks/useUserIdentity';
// import useMutual from 'hooks/useMutual';
import useIdentity from 'hooks/useIdentity';
import useUserIdentity from 'hooks/useUserIdentity';
import useDedicitedAssignment from 'hooks/useDedicatedAssignment';

import { JoyTypeLevels } from '../types';
type InteractiveType = boolean | 'link' | undefined;

const IdentityTextChunk = observer(({ identity, interactive=undefined, level="inherit" }: { identity: Identity, interactive?: InteractiveType, level?: JoyTypeLevels }) => {
    const { currentIdentity } = useUserIdentity();
    const { isDedicatedFor } = useDedicitedAssignment();
    const location = useLocation();

    const navigate = useNavigate();
    //    const PageLinkIcon = getIcon('Link');
    if(!identity?.name) {
        return <Skeleton variant="text" width={100} sx={{ml:1}} />;
    }
    function getLink() {
        const identity_url = `/identity/${identity.uuid}`;
        const dedicated_url = `/dedicated/${identity.uuid}`;
        // if we're on the dedicate page, always redirect to identity
        // we want them to be able to get there at some point
        if(location.pathname == dedicated_url)
            return identity_url;

        // Link to dedicated_url if they're a dedicated assistant for
        // this person. Otherwise, just the regular url
        return isDedicatedFor(currentIdentity?.uuid, identity.uuid) ?
            dedicated_url : identity_url;
    }
    return (
        <Stack>
            <Typography
                sx={{
                    cursor: (interactive ? "pointer" : undefined),
                }}
                level={level}
                component="span"
                onClick={(e) => {
                    if (interactive) {
                        e.preventDefault();
                        navigate(getLink());
                     }
                }}
            >{identity.name}
            </Typography>

        </Stack>
    );

});

const IdentityAvatar = observer(({ identityKey, size = "", interactive=true, level="inherit", providedIdentity=undefined, width=0, height=0 }:
{ identityKey: string | undefined, size: string, interactive?: InteractiveType, level?: JoyTypeLevels, providedIdentity?: Identity | undefined, width?: number, height?: number }) => {

    const { fetchIdentity, getIdentity } = useIdentity();
    const { currentIdentity } = useUserIdentity();
    const identity = providedIdentity ? providedIdentity : getIdentity(identityKey || '');

    useEffect(() => {
        if (identityKey && currentIdentity?.uuid) {
            fetchIdentity(currentIdentity?.uuid, identityKey);
        }
    }, [identityKey, currentIdentity?.uuid]);

    if (!identity) {
        return <Skeleton width={85} variant="text" />
    }

    var avatarSize = (size == 'avatar') ?
        { width: 32, height: 32} :
        { width: 24, height: 24};
    if (size == 'chip') {
        avatarSize = { width: 16, height: 16};
    }
    if(width) {
        avatarSize.width = width;
    }
    if(height) {
        avatarSize.height = height;
    }


    const tt = identity.role == 'assistant' ? identity.name : undefined;
    const A = <Tooltip arrow title={tt}>
        <Avatar
            variant={identity.role == 'assistant' ? 'rounded' : undefined}
            sx={{ bgcolor: identity.color, ...avatarSize }} />
    </Tooltip>;

    if (size == 'avatar') {
        return A;
    }
    else if (size == 'chip') {
        return (
            <Chip sx={{ cursor: 'default'}} startDecorator={A} >
                <IdentityTextChunk level={level} interactive={interactive} identity={identity}  />
            </Chip>
        );
    }
    else if(size == 'name') {
        return (
            <IdentityTextChunk level={level}  interactive={interactive} identity={identity} />
        );
    }
    else if (size == 'inherit') {
        // pass the level
        return (
            <Stack direction="row" alignItems="center" spacing={1} >
                {A}
                    <IdentityTextChunk  level={level}  interactive={interactive} identity={identity}  />
            </Stack>
        );
    }

    else if (size == 'inline') {
        // this is just body-sm
        return (
            <Stack direction="row" alignItems="center" spacing={1} >
                {A}
                <IdentityTextChunk level={level === 'inherit' ? "body-sm" : level}  interactive={interactive} identity={identity}  />
            </Stack>
        );
    }

    else if (size == 'menu') {
        return (
            <>
                <ListItemDecorator>{A}</ListItemDecorator>
                <ListItemContent>
                    <IdentityTextChunk level={level}  interactive={false} identity={identity}   />
                </ListItemContent>
                {/* <PresenceIndicatorAndControls identity={identity} /> */}
            </>
        );
    }

    return (
        <Card>
            <Stack direction='row' spacing={1} alignItems="center">
            {A}
            <IdentityTextChunk  level={level}  interactive={interactive} identity={identity} />
            </Stack>
        </Card>
    );

});

export default IdentityAvatar;
